import { render, staticRenderFns } from "./cowinfo.vue?vue&type=template&id=e9cceeb4&scoped=true&"
import script from "./cowinfo.vue?vue&type=script&lang=js&"
export * from "./cowinfo.vue?vue&type=script&lang=js&"
import style0 from "./cowinfo.vue?vue&type=style&index=0&id=e9cceeb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cceeb4",
  null
  
)

export default component.exports